export default __webpack_public_path__ + "static/media/phone.bed52adf.gif";